import React from 'react';
import './BottomBar.css';
import { Link } from 'react-router-dom';



const BottomBar = ({setPagePosition}) => {

    return (

        <div className='BottomBar'>
            <div className='BottomBarWrapper'>
                <Link className='Datenschutz' to = "Datenschutzerklaerung" onClick={()=>{setPagePosition(8);}}>
                    Datenschutz
                </Link>
                <Link className='Impressum' to = "Impressum" onClick={()=>{setPagePosition(9);}}>
                    Impressum
                </Link>

            </div>

        </div>
    );

}

export default BottomBar; 